export default __webpack_public_path__ + "static/media/plus.881e8367.svg";